import axios from 'axios';
// import 'rxjs/add/operator/mergeMap';
// import 'rxjs/add/operator/debounceTime';
import 'rxjs';

import {
  FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS,
  FETCH_SALES_ORDER_SUGGESTIONS_FAILURE,
  FETCH_SALES_ORDER_SUGGESTIONS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE,
  FETCH_PRODUCT_SUGGESTIONS,
  FETCH_PRODUCT_SUGGESTIONS_SUCCESS,
  FETCH_PRODUCT_SUGGESTIONS_FAILURE,
} from './type';

import {
  SALES_ORDER_SUGGESTION_URL,
  PURCHASE_ORDER_SUGGESTION_URL,
} from './url';

export function fetchSalesOrderSuggestions(customerNumber, searchType, value) {
  return (dispatch) => {
    dispatch({ type: FETCH_SALES_ORDER_SUGGESTIONS, payload: { customerNumber, searchType, value } });
  };
}

export const SalesAutoSuggestEpic = action$ =>
  action$.ofType(FETCH_SALES_ORDER_SUGGESTIONS)
    .switchMap(action =>
      axios.get(
        `${SALES_ORDER_SUGGESTION_URL}${action.payload.customerNumber}/?${action.payload.searchType}=${action.payload.value}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS, payload: response }))
    .catch((err, source) => {
      return source;
    });

export function fetchPurchaseOrderSuggestions(searchType, value) {
  return (dispatch) => {
    dispatch({ type: FETCH_PURCHASE_ORDER_SUGGESTIONS, payload: { searchType, value } });
  };
}

export const PurchaseAutoSuggestEpic = action$ =>
  action$.ofType(FETCH_PURCHASE_ORDER_SUGGESTIONS)
    .switchMap(action =>
      axios.get(
        `${PURCHASE_ORDER_SUGGESTION_URL}?${action.payload.searchType}=${action.payload.value}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS, payload: response }))
    .catch(err => ({ type: FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE, payload: err }));


export function fetchProductSuggestions(searchType, value) {
  return (dispatch) => {
    dispatch({ type: FETCH_PRODUCT_SUGGESTIONS, payload: { searchType, value } });
  };
}

export const ProductAutoSuggestEpic = action$ =>
  action$.ofType(FETCH_PRODUCT_SUGGESTIONS)
    .switchMap(action =>
      axios.get(
        `${PURCHASE_ORDER_SUGGESTION_URL}?${action.payload.searchType}=${action.payload.value}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_PRODUCT_SUGGESTIONS_SUCCESS, payload: response }))
    .catch(err => ({ type: FETCH_PRODUCT_SUGGESTIONS_FAILURE, payload: err }));



// WEBPACK FOOTER //
// ./master/jsx/actions/autoSuggest_actions.js